import { Injectable, inject } from '@angular/core';
// import {Actions, createEffect, Effect, ofType} from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { StoreService } from "../../home/services/store.service";
import { Helper } from "../../shared/services/Helper.service";
import {
	ActionTypes,
	GetStoreById,
	GetStoreByIdError,
	GetStoreByIdSuccess,
	GetStores, GetStoresError,
	GetStoresSuccess
} from "./store.actions";
import { GetAllTypes, GetItemsByStoreId } from "../Item/item.actions";
import { EmptyCriteria } from "../../shared/interfaces/CriteriaModel";

@Injectable()
export class StoreEffects {

	// @Effect()
	// GetStoreById$ = this.actions$.pipe(
	GetStoreById$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoreById),
			map((action: GetStoreById) => action.payload),
			mergeMap((payload) => {
				// let storeData = localStorage.getItem('SELECTED_STORE');
				// if (storeData) {
				// 	storeData = JSON.parse(storeData);
				// 	return of(new GetStoreByIdSuccess(storeData));
				// } else {
				return this.storeService.GetStoreById(payload.storeId).pipe(
					map((response) => {
						return new GetStoreByIdSuccess(response);
					}),
					catchError((error) => of(new GetStoreByIdError(error)))
				)
				// }
			})
		)
	});
	// );

	GetStoreByIdSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoreByIdSuccess),
			map((action: GetStoreByIdSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null);
			})
		);
	}, { dispatch: false });

	// @Effect({ dispatch: false })
	// GetStoreByIdError$ = this.actions$.pipe(
	GetStoreByIdError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoreByIdError),
			map((action: GetStoreByIdError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetStores$ = this.actions$.pipe(
	GetStores$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStores),
			map((action: GetStores) => action.payload),
			mergeMap((payload) => {
				return this.storeService.GetStores(payload).pipe(
					map((response) => {
						return new GetStoresSuccess(response);
					}),
					catchError((error) => of(new GetStoresError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetStoresSuccess$ = this.actions$.pipe(
	GetStoresSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoresSuccess),
			map((action: GetStoresSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetStoresError$ = this.actions$.pipe(
	GetStoresError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetStoresError),
			map((action: GetStoresError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private storeService: StoreService,
		private helper: Helper,
	) {
	}
}
